import { useCallback, useState } from 'react';

export function UseAccordion(initial = false) {
  const [expanded, setExpanded] = useState(Boolean(initial));

  const open = useCallback(() => setExpanded(true), []);
  const close = useCallback(() => setExpanded(false), []);
  const toggle = useCallback(() => setExpanded(v => !v), []);

  // Handler compatible con MUI Accordion
  const onChange = useCallback((_, v) => setExpanded(v), []);

  return { expanded, setExpanded, open, close, toggle, onChange };
}